import { Box, Button } from "@mui/material";
import { colors } from "../../../../../../../theme/muiColors";
import { BenefitDisableGate } from "../../../../../../../permissions/benefits/components/gates/BenefitDisabledGate";
import { EBenefitTypes, EShowMode } from "../../../../../../../permissions/benefits/enums/benefits.enums";
import { EMode } from "../../enums/event.enums";

interface Props {
  isModeDisabled: (mode: EMode) => boolean;
  value: EMode;
  isDisabled: boolean;
  onChange: (mode: EMode) => void;
}

const SELECTED_COLOR = colors.orange[300];
const SELECTED_BORDER_COLOR = colors.orange[300];
export const ScheduleSelector = ({ value, onChange, isDisabled, isModeDisabled }: Props) => {
  const handleSelect = (mode: EMode) => {
    if (mode !== value) onChange(mode);
  };

  return (
    <Box
      sx={{
        display: "flex",
        gap: 1,
        p: 0.5,
        borderRadius: "10px",
        bgcolor: "var(--fx-surface-sunken, #F8FAFC)",
        mb: 1,
      }}
    >
      {!isModeDisabled(EMode.SINGLE_EXECUTION) && (
        <Button
          variant={value === EMode.SINGLE_EXECUTION ? "contained" : "text"}
          onClick={() => handleSelect(EMode.SINGLE_EXECUTION)}
          disabled={isDisabled}
          sx={{
            flex: 1,
            borderRadius: "8px",
            boxShadow: value === EMode.SINGLE_EXECUTION ? 2 : 0,
            color: value === EMode.SINGLE_EXECUTION ? "var(--fx-surface-text, #0F172A)" : "var(--fx-surface-texttertiary, #94A3B8)",
            bgcolor: value === EMode.SINGLE_EXECUTION ? SELECTED_COLOR : "transparent",
            textTransform: "none",
            fontWeight: 500,
            fontSize: 14,
            "&:hover": {
              bgcolor: value === EMode.SINGLE_EXECUTION ? SELECTED_COLOR : "transparent",
            },
          }}
        >
          One time
        </Button>
      )}

      {!isModeDisabled(EMode.REPETITIVE) && (
        <BenefitDisableGate
          benefit={EBenefitTypes.SCHEDULING}
          showWhenBlocked={EShowMode.DISABLED}
          overlay={true}
          overlayLabel={"Blocked"}
          blockedTooltip={"Upgrade your plan to access this feature"}
          overlaySx={{ flex: 1, width: "100%" }}
          sx={{ flex: 1 }}
          children={
            <Button
              variant={value === EMode.REPETITIVE ? "contained" : "text"}
              onClick={() => handleSelect(EMode.REPETITIVE)}
              disabled={isDisabled}
              sx={{
                flex: 1,
                borderRadius: "8px",
                boxShadow: value === EMode.REPETITIVE ? 2 : 0,
                color: value === EMode.REPETITIVE ? "var(--fx-surface-text, #0F172A)" : "var(--fx-surface-texttertiary, #94A3B8)",
                bgcolor: value === EMode.REPETITIVE ? SELECTED_COLOR : "transparent",
                textTransform: "none",
                fontWeight: 500,
                fontSize: 14,
                "&:hover": {
                  bgcolor: value === EMode.REPETITIVE ? SELECTED_COLOR : "transparent",
                },
              }}
            >
              Recurrent
            </Button>
          }
        ></BenefitDisableGate>
      )}
    </Box>
  );
};
